import React from 'react';
import { Container } from './ui/Container';
import { CheckCircleIcon, BookOpenIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-brand-cream-50" data-id="element-55">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-cream-100/50 -skew-x-12 translate-x-1/4 pointer-events-none" data-id="element-56" />
      <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none mix-blend-multiply" data-id="element-57"></div>

      <Container className="relative z-10" data-id="element-58">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-59">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-60">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-amber-100 text-brand-amber-700 text-sm font-semibold mb-6" data-id="element-61">
              <span className="relative flex h-2 w-2" data-id="element-62">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-amber-400 opacity-75" data-id="element-63"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-amber-500" data-id="element-64"></span>
              </span>
              Recursos 100% Digitales y Editables
            </div>

            <h1 className="text-4xl lg:text-6xl font-bold text-brand-navy-900 leading-[1.1] mb-6" data-id="element-65">
              Recursos Educativos{' '}
              <span className="text-brand-amber-500" data-id="element-66">Profesionales</span> Para
              Docentes
            </h1>

            <p className="text-lg lg:text-xl text-brand-navy-700 mb-8 max-w-lg leading-relaxed" data-id="element-67">
              Somos una plataforma dedicada a la creación de MegaPacks de ebooks
              educativos diseñados para docentes de nivel bachiller. Materiales
              claros, estructurados y aplicables en contextos educativos reales.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-68">
              <a href="#beneficios" className="inline-flex items-center justify-center h-14 px-8 text-lg font-semibold rounded-lg bg-brand-amber-500 text-white hover:bg-brand-amber-600 transition-colors shadow-lg shadow-brand-amber-500/20 w-full sm:w-auto" data-id="element-69">
                Conoce Nuestros Recursos
              </a>
              <a href="#como-funciona" className="inline-flex items-center justify-center h-14 px-8 text-lg font-semibold rounded-lg border-2 border-brand-navy-900 text-brand-navy-900 hover:bg-brand-navy-900/5 transition-colors w-full sm:w-auto" data-id="element-70">
                ¿Cómo Funciona?
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8 text-sm text-brand-navy-700 font-medium" data-id="element-71">
              <div className="flex items-center gap-2" data-id="element-72">
                <CheckCircleIcon className="text-green-600 h-5 w-5" data-id="element-73" />
                <span data-id="element-74">Entrega Digital Inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-75">
                <CheckCircleIcon className="text-green-600 h-5 w-5" data-id="element-76" />
                <span data-id="element-77">Operados por TGT FLIP LLC</span>
              </div>
            </div>
          </motion.div>

          {/* Hero Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-78">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-white" data-id="element-79">
              <div className="aspect-[4/3] bg-brand-navy-900 p-8 flex flex-col justify-center items-center text-center relative overflow-hidden" data-id="element-80">
                <div className="absolute inset-0 bg-grid-white/[0.05] bg-[length:20px_20px]" data-id="element-81" />
                <div className="absolute -top-24 -right-24 w-64 h-64 bg-brand-amber-500 rounded-full blur-3xl opacity-20" data-id="element-82" />

                <BookOpenIcon className="h-20 w-20 text-brand-amber-500 mb-6 relative z-10" data-id="element-83" />
                <h3 className="text-2xl font-bold text-white mb-2 relative z-10" data-id="element-84">
                  MegaPacks Educativos
                </h3>
                <p className="text-brand-cream-100 relative z-10" data-id="element-85">
                  Planificaciones • Actividades • Evaluaciones
                </p>

                <motion.div animate={{
                y: [0, -10, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute bottom-8 left-8 bg-white/10 backdrop-blur-md p-3 rounded-lg border border-white/20" data-id="element-86">
                  <div className="h-2 w-24 bg-white/40 rounded mb-2" data-id="element-87" />
                  <div className="h-2 w-16 bg-white/20 rounded" data-id="element-88" />
                </motion.div>

                <motion.div animate={{
                y: [0, 10, 0]
              }} transition={{
                duration: 5,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1
              }} className="absolute top-8 right-8 bg-white/10 backdrop-blur-md p-3 rounded-lg border border-white/20" data-id="element-89">
                  <div className="h-8 w-8 rounded-full bg-brand-amber-500/80 flex items-center justify-center text-white font-bold text-xs" data-id="element-90">
                    PDF
                  </div>
                </motion.div>
              </div>
            </div>

            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-amber-500/10 blur-3xl rounded-full" data-id="element-91" />
          </motion.div>
        </div>
      </Container>
    </section>;
}